import React from 'react';
import { connect } from 'react-redux';
import { openModal } from '../../actions/ModalActions';
import CreateContactModal from '../../components/CreateContactModal';
import { EVALUATION_CLIENT_STAGE_ID } from '../../constants/clientStages';
import ShortcutButton from '../shortcut-button/ShortcutButton';
import { goToStep, updateCallData, completeWizard, goBack, goToFollowUpCallStep, goToBookMeetingStep } from './logActivityReducer';
import CompleteButton from './CompleteButton';

@connect(
    state => ({
        contacts: state.activeClient.contacts,
        client: state.activeClient.client,
        date: state.logActivityWizard.callData.date,
        participatingContactId: state.logActivityWizard.callData.participatingContactId,
        hadDemo: state.activeClient.client.hadDemo
    }),
    { openModal, goToStep, updateCallData, completeWizard, goBack, goToFollowUpCallStep, goToBookMeetingStep }
)
export default class ConversationStep extends React.Component {
    handleContactChange(participatingContactId) {
        this.props.updateCallData({participatingContactId});
    }
    showCreateContactModal(e) {
        e.preventDefault();
        this.props.openModal(CreateContactModal, {clientId: this.props.client.id});
    }
    canSubmit() {
    	return true;
    }
    renderNextAction() {
        var { client, goToStep, completeWizard, goToFollowUpCallStep, goToStep, goToBookMeetingStep, updateCallData } = this.props;

        var isClientInEvaluationStage = client.clientStageId == EVALUATION_CLIENT_STAGE_ID;

        if(client.isPaying) {
            return (
                <PayingUserConversationActions 
                    completeWizard={completeWizard}
                    goToBookMeetingStep={goToBookMeetingStep}
                    goToFollowUpCallStep={goToFollowUpCallStep}
                    goToStep={goToStep} 
                    canSubmit={this.canSubmit()} />
            );
        }

        // SETUP_CLIENT_STAGE_ID

        if(isClientInEvaluationStage) {
            return (
                <EvaluateGoodFitConversationActions 
                    updateCallData={updateCallData}
                    client={client}
                    goToFollowUpCallStep={goToFollowUpCallStep}
                    completeWizard={completeWizard}
                    goToStep={goToStep} 
                    canSubmit={this.canSubmit()} />
            );
        }

        if(! client.hadDemo) {
            return (
                <SetupActions 
                    goToBookMeetingStep={goToBookMeetingStep}
                    goToFollowUpCallStep={goToFollowUpCallStep}
                    goToStep={goToStep} 
                    canSubmit={this.canSubmit()} />
            );
        }

        if(client.hadDemo) {
            return (
                <HadDemoActions 
                    goToBookMeetingStep={goToBookMeetingStep}
                    goToFollowUpCallStep={goToFollowUpCallStep}
                    goToStep={goToStep} 
                    canSubmit={this.canSubmit()} />
            );
        }

        alert('The Wizard could not find next step :(');
    }
    render() {
        return (
        	<div className="wizard-step-wrapper">
                <h1>The conversation</h1>
                <div>
                    <h2>
                        Contact called 
                    </h2>

                </div>
        	</div>
        );
    }
}

class EvaluateGoodFitConversationActions extends React.Component {
    badFit() {
        this.props.goToStep('MarkAsDudStep');       
    }
    ongoing() {
        this.props.goToFollowUpCallStep();
    }
    async goodFit() {
        // if has a fergus account go to book a follup step
        // else go to the folllow up options step

        this.props.updateCallData({callDeterminedClientAsGoodFit: true});

        if(this.props.client.fergusId) {
            this.props.goToStep('BookFollowUpOptionsStep');  
        } else {
            this.props.goToStep('WarnAgainstNoFergusAccountStep');            
        }
    }
    render() {
        var { canSubmit } = this.props;
        return (
            <div className="actions-row" style={{marginTop: 30}}>
                <ShortcutButton shortcut="b" type="danger" disabled={! canSubmit} onClick={this.badFit.bind(this)}>
                    Bad fit
                </ShortcutButton>
                <ShortcutButton shortcut="o" type="warning" disabled={! canSubmit} onClick={this.ongoing.bind(this)}>
                    Ongoing
                </ShortcutButton>
                <ShortcutButton shortcut="g" type="success" disabled={! canSubmit} onClick={this.goodFit.bind(this)}>
                    Good fit
                </ShortcutButton>
            </div>
        );      
    }
}

class HadDemoActions extends React.Component {
    badFit() {
        this.props.goToStep('MarkAsDudStep');       
    }
    ongoing() {
        this.props.goToFollowUpCallStep();
    }
    bookTraining() {
        // @todo make sure training type
        this.props.goToBookMeetingStep();
    }
    render() {
        var { canSubmit } = this.props;
        return (
            <div style={{marginTop: 30, display: 'flex'}}>
                <ShortcutButton shortcut="b" type="danger" disabled={! canSubmit} onClick={this.badFit.bind(this)}>
                    Bad fit
                </ShortcutButton>
                <ShortcutButton shortcut="o" type="warning" disabled={! canSubmit} onClick={this.ongoing.bind(this)}>
                    Ongoing
                </ShortcutButton>
                <ShortcutButton shortcut="t" type="success" disabled={! canSubmit} onClick={this.bookTraining.bind(this)}>
                    Training
                </ShortcutButton>
            </div>
        );      
    }
}

class SetupActions extends React.Component {
    badFit() {
        this.props.goToStep('MarkAsDudStep');       
    }
    ongoing() {
        this.props.goToFollowUpCallStep();
    }
    bookDemo() {
        // @todo make sure booking type
        this.props.goToBookMeetingStep();
    }
    render() {
        var { canSubmit } = this.props;
        return (
            <div style={{marginTop: 30, display: 'flex'}}>
                <ShortcutButton shortcut="b" type="danger" disabled={! canSubmit} onClick={this.badFit.bind(this)}>
                    Bad fit
                </ShortcutButton>
                <ShortcutButton shortcut="o" type="warning" disabled={! canSubmit} onClick={this.ongoing.bind(this)}>
                    Ongoing
                </ShortcutButton>
                <ShortcutButton shortcut="d" type="success" disabled={! canSubmit} onClick={this.bookDemo.bind(this)}>
                    Book Demo
                </ShortcutButton>
            </div>
        );      
    }
}

class PayingUserConversationActions extends React.Component {
	bookFollowUpCall() {
        this.props.goToFollowUpCallStep();
	}
	bookFollowUpMeeting() {
        this.props.goToBookMeetingStep();
	}
	complete() {
		this.props.completeWizard();
	}
	render() {
		var { canSubmit } = this.props;
		return (
	        <div style={{marginTop: 30, display: 'flex'}}>
                <ShortcutButton shortcut="c" type="success" disabled={! canSubmit} onClick={this.bookFollowUpCall.bind(this)}>
                    Follow up call
                </ShortcutButton>
                <ShortcutButton shortcut="m" type="success" disabled={! canSubmit} onClick={this.bookFollowUpMeeting.bind(this)}>
                    Follow up meeting
                </ShortcutButton>
                <CompleteButton />
	        </div>
		);		
	}
}


// WEBPACK FOOTER //
// ./app/components/schedule-wizard/ConversationStep.js